import moment from "moment";

export const formatDate = (date: string, formatType = "DD/MM/YYYY") => {
  return moment(date).format(formatType);
};
